module.exports = __webpack_public_path__ + "img/8.38f83796.png";